import { Loader } from "./loader";

interface LoadingPageProps {
  message?: string;
}

export function LoadingPage({ message = "Loading page..." }: LoadingPageProps) {
  return (
    <div className="flex h-[80vh] w-full items-center justify-center">
      <Loader size={32} text={message} />
    </div>
  );
} 